import { render, staticRenderFns } from "./terms-use.vue?vue&type=template&id=39ffb5de&scoped=true"
import script from "./terms-use.vue?vue&type=script&lang=js"
export * from "./terms-use.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ffb5de",
  null
  
)

export default component.exports